<script lang="ts" module>
	export const symbolId = "ishavskraft-icon-exclamation-outline";
	export const symbol = `
		<symbol id="${symbolId}" viewBox="0 0 20 20">
			<path
				d="M10 15C10.2833 15 10.521 14.904 10.713 14.712C10.905 14.52 11.0007 14.2827 11 14V9.975C11 9.69167 10.904 9.45833 10.712 9.275C10.52 9.09167 10.2827 9 10 9C9.71667 9 9.479 9.096 9.287 9.288C9.095 9.48 8.99933 9.71733 9 10V14.025C9 14.3083 9.096 14.5417 9.288 14.725C9.48 14.9083 9.71733 15 10 15ZM10 7C10.2833 7 10.521 6.904 10.713 6.712C10.905 6.52 11.0007 6.28267 11 6C11 5.71667 10.904 5.479 10.712 5.287C10.52 5.095 10.2827 4.99933 10 5C9.71667 5 9.479 5.096 9.287 5.288C9.095 5.48 8.99933 5.71733 9 6C9 6.28333 9.096 6.521 9.288 6.713C9.48 6.905 9.71733 7.00067 10 7ZM10 20C8.61667 20 7.31667 19.7373 6.1 19.212C4.88333 18.6867 3.825 17.9743 2.925 17.075C2.025 16.175 1.31267 15.1167 0.788 13.9C0.263333 12.6833 0.000666667 11.3833 0 10C0 8.61667 0.262667 7.31667 0.788 6.1C1.31333 4.88333 2.02567 3.825 2.925 2.925C3.825 2.025 4.88333 1.31267 6.1 0.788C7.31667 0.263333 8.61667 0.000666667 10 0C11.3833 0 12.6833 0.262667 13.9 0.788C15.1167 1.31333 16.175 2.02567 17.075 2.925C17.975 3.825 18.6877 4.88333 19.213 6.1C19.7383 7.31667 20.0007 8.61667 20 10C20 11.3833 19.7373 12.6833 19.212 13.9C18.6867 15.1167 17.9743 16.175 17.075 17.075C16.175 17.975 15.1167 18.6877 13.9 19.213C12.6833 19.7383 11.3833 20.0007 10 20ZM10 18C12.2167 18 14.1043 17.221 15.663 15.663C17.2217 14.105 18.0007 12.2173 18 10C18 7.78333 17.221 5.89567 15.663 4.337C14.105 2.77833 12.2173 1.99933 10 2C7.78333 2 5.89567 2.779 4.337 4.337C2.77833 5.895 1.99933 7.78267 2 10C2 12.2167 2.779 14.1043 4.337 15.663C5.895 17.2217 7.78267 18.0007 10 18Z"
				fill="currentColor"
			/>
		</symbol>`;
</script>

<script lang="ts">
	import type { ClassValue } from "svelte/elements";

	let {
		class: classes = null,
		ariaHidden = true,
	}: {
		class?: ClassValue | null;
		ariaHidden?: boolean;
	} = $props();
</script>

<svg
	aria-hidden={ariaHidden}
	class={classes}
	width="20"
	height="20"
	viewBox="0 0 20 20"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
>
	<use href="#{symbolId}" />
</svg>
